import { IEntity } from "./Entity";

export interface ICAPeriod extends IEntity {
    PeriodStatus?: string;
    PeriodStartDate?: Date;
    PeriodEndDate?: Date;
}
export class CAPeriod implements ICAPeriod{
    public ID: number = null;
    public Title: string = null;
    public PeriodStatus = null;
    public PeriodStartDate = null;
    public PeriodEndDate = null;
  }